<div *ngIf="recipeList$ | async as recipeList; else loading;">

  <div class="summary pageBreak">
    <div class="summary--image">
      <img class="my" src="/assets/images/meal-planning/my.svg" alt="My" />
      <img class="hero" src="/assets/images/meal-planning/meal-planning-hero-1@1x.jpg" alt="Meal Planner" />
      <img class="wapple" src="/logos/cd_logo_wapple.svg" alt="My Meal Planner" />
      <div>
        <h1 i18n="@@mealPlanningHeader"><span class="sr-only my">my&nbsp;</span>meal planner</h1>
      </div>
    </div>
    <div class="summary--title">
      <h2>My meal plan</h2>
      <p>Printed on {{ date }} <span>|</span> {{ recipeList.length }} recipes <span>|</span> Total {{ ingredientCount$ | async }} ingredients </p>
    </div>
    <ul class="summary--table">
      <li *ngFor="let recipe of recipeList">
        <div class="summary--info-title">
          <div>
            <cdx-icon-circle borderColor="light-green" size="large" borderWidth="6px">
              <img [src]="recipe.largeImageFilename || recipe.smallImageFilename" [alt]="recipe.title" (load)="updateImageLoadedCount()"/>
            </cdx-icon-circle>
          </div>
          <div>
            <h3 class="heading--3">{{ recipe.title }}</h3>
          </div>
        </div>
        <div class="summary--info-container">
          <div class="summary--info" *ngIf="recipe.prepDuration">
            <cdx-svg-icon name="knife" fill="dark" size="small"></cdx-svg-icon>
            <p>{{ recipe.prepDuration }} mins</p>
          </div>
          <div class="summary--info" *ngIf="recipe.cookingDuration">
            <cdx-svg-icon name="casserole" fill="dark" size="small"></cdx-svg-icon>
            <p>{{ recipe.cookingDuration }} mins</p>
          </div>
          <div class="summary--info" *ngIf="recipe.servings">
            <cdx-svg-icon name="bowl" fill="dark" size="small"></cdx-svg-icon>
            <p>Serves {{ recipe.servings }}</p>
          </div>
          <div class="summary--info" *ngIf="recipe.ingredients">
            <cdx-svg-icon name="avocado" fill="dark" size="small"></cdx-svg-icon>
            <p>{{ recipe.ingredients.length }} ingredients</p>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div *ngFor="let recipe of recipeList; let last = last" class="recipe">
    <div class="recipeDetails-section recipeDetails-section--header recipeDetails-section--white">
      <recipe-details-header
        [id]="recipe.id"
        [title]="recipe.title"
        [description]="recipe.description"
        [imageUrl]="recipe.largeImageFilename || recipe.smallImageFilename"
        [mealTimes]="recipe.mealtimes?.split(',') || []"
        [prepDuration]="recipe.prepDuration"
        [cookDuration]="recipe.cookingDuration"
        [servings]="recipe.servings"
        [saved]="recipe.saved"
        [nutritionTags]="recipe.nutritionTags"
      ></recipe-details-header>
    </div>

    <div class="recipeDetails-section recipeDetails-section--method recipeDetails-section--white" [class.pageBreak]="!last">
      <recipe-method
        [id]="recipe.id"
        [title]="recipe.title"
        [servings]="recipe.servings"
        [method]="recipe.instructions"
        [ingredients]="recipe.ingredients"
        [contributorLink]="recipe.webpageLink"
        [contributorName]="recipe.contributorName"
        [contributorTown]="recipe.contributorTown"
        [modalOutletName]="'PLACEHOLDER-NAME'"
      ></recipe-method>
    </div>
  </div>
</div>

<ng-template #loading>
  <cdx-wapple-loading></cdx-wapple-loading>
</ng-template>
